import {
    type PropsWithChildren,
    useContext,
    useMemo
} from 'react';

import { AuthContext } from '../../../contexts/auth/AuthContext';

import PromptService from '../services/PromptService';
import PromptProvider from './PromptContext';

const PromptServiceProvider: React.FC<PropsWithChildren> = ({ children }) => {
    const { getAccessToken } = useContext(AuthContext);
    const service = useMemo(
        () => new PromptService(getAccessToken),
        [getAccessToken]
    );

    return (
        <PromptProvider service={service}>
            {children}
        </PromptProvider>
    );
};

export default PromptServiceProvider;